class ContractFormCache {
	storage = {};

	/**
	 * @param {string} key
	 */
	getItem(key) {
		if (!Reflect.has(this.storage, key)) {
			return null;
		}

		return this.storage[key];
	}

	setItem(key, value) {
		this.storage[key] = value;
	}
}

/**
 * @returns {ContractFormCache}
 */
function cache() {
	window.contractFormCache = window.contractFormCache || new ContractFormCache();

	return window.contractFormCache;
}
